export default __webpack_public_path__ + "media/products/plus-51aecc7a.png";